import { render } from "./BusesList.vue?vue&type=template&id=0ce76eb8"
import script from "./BusesList.vue?vue&type=script&lang=js"
export * from "./BusesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__